import React from 'react';
import {connect} from 'react-redux';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {changeBPM} from 'engine/mix/actions.js';

const BpmSlider = ({bpm, sequencerEngine}) => {
    return (
        <div className="bpm-container">
          <div className="bpm-label">BPM: {Math.round(bpm)}</div>
          <ReactBootstrapSlider
            value={bpm}
            change={(e) => sequencerEngine.dispatch(changeBPM(e.target.value))}
            step={1}
            className="bpm-fader"
            max={250}
            min={1}
            orientation="horizontal"
            reversed={false}/>
        </div>
    );
};

const mapStateToProps = (state, props) => {
    return {
        bpm: state.user.bpm
    };
};

export default connect(mapStateToProps, null)(BpmSlider);


